// Shim for @ember/test to prevent errors when ember-testing is not available
// This provides minimal test infrastructure for development mode

// Create a fake Test object that matches what @ember/test exports
const Test = {
  registerWaiter(/* callback, context */) {
    // No-op in development mode
    return undefined;
  },

  unregisterWaiter(/* callback, context */) {
    // No-op in development mode
    return undefined;
  },

  registerAsyncHelper(/* name, helperFunction */) {
    // No-op in development mode
    return undefined;
  },

  unregisterAsyncHelper(/* name */) {
    // No-op in development mode
    return undefined;
  },

  registerHelper(/* name, helperFunction */) {
    // No-op in development mode
    return undefined;
  },

  unregisterHelper(/* name */) {
    // No-op in development mode
    return undefined;
  }
};

export default Test;

// Also export the functions directly for named imports
export const registerWaiter = Test.registerWaiter;
export const unregisterWaiter = Test.unregisterWaiter;
export const registerAsyncHelper = Test.registerAsyncHelper;
export const unregisterAsyncHelper = Test.unregisterAsyncHelper;
export const registerHelper = Test.registerHelper;
export const unregisterHelper = Test.unregisterHelper;
